import { render, staticRenderFns } from "./overallStatus.vue?vue&type=template&id=32b9f4ed&scoped=true"
import script from "./overallStatus.vue?vue&type=script&lang=js"
export * from "./overallStatus.vue?vue&type=script&lang=js"
import style0 from "./overallStatus.vue?vue&type=style&index=0&id=32b9f4ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b9f4ed",
  null
  
)

export default component.exports